import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { signOutWithSip } from 'store/actions/auth'
import { PageHeader, ModalAsDropdown, ModalStyles } from 'components/shared'
import Webphone from 'common/Webphone'
import { ModeTypes } from 'common/Enums'
import { AppUrls } from 'common/AppUrls'
import { SettingsPages } from './config/SettingsConfig'
import { ModeDropdownConfig } from './config/ModeDropdownConfig'
import { ModeSelect } from './components/ModeSelect'
import { ReactComponent as CheckBlueIcon } from 'assets/svg/shared/check_blue.svg'
import { setUserMode } from 'store/actions/settings'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'
import './Settings.scss'

export function Settings({ history }) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const profileData = useSelector((state) => state.profile.data)

    // State
    const [isModalVisible, setModalVisible] = useState(false)
    const [modalStyles, setModalStyles] = useState(ModalStyles)

    // Actions
    const toggleModal = () => {
        const appContainerHeight = +sessionStorage.getItem('appHeight')
        const windowHeight = window.innerHeight
        const bottomRetreat = (windowHeight - appContainerHeight) / 2

        setModalStyles({
            ...modalStyles,
            content: {
                ...modalStyles.content,
                bottom: `${bottomRetreat + 24}px`
            }
        })

        setModalVisible(!isModalVisible)
    }

    const selectedMode = useSelector((state) => state.settings.mode)

    const onModeSelect = (modeId) => {
        dispatch(setUserMode(modeId))

        switch (modeId) {
            case ModeTypes.Available:
                !isEmpty(profileData) && Webphone.init(profileData)
                break
            case ModeTypes.Unavailable:
                Webphone.unregister()
                break
            default:
                break
        }

        toggleModal()
    }

    function logoutHandle() {
        dispatch(signOutWithSip())
    }

    // Renders
    function modalContent() {
        return ModeDropdownConfig.map(({ id, name, icon }) => (
            <div
                key={id}
                className="settings__select__item d-flex align-items-center justify-content-between"
                onClick={() => onModeSelect(id)}
            >
                <div className="settings__select__status d-flex align-items-center">
                    {icon}
                    {t(`connectionstate.${name}`)}
                </div>
                {id === selectedMode && <CheckBlueIcon width={18} />}
            </div>
        ))
    }

    return (
        <div className="settings d-flex flex-column flex-fill">
            <PageHeader pageName={t('navigation.settings')} />
            <div>
                {SettingsPages.map(({ id, icon, name, url, disabled = false }) => (
                    !disabled && <div
                        key={id}
                        className="settings__nav-item d-flex align-items-center"
                        onClick={() => (url === AppUrls.logout ? logoutHandle() : history.push(url))}
                    >
                        {icon}
                        {t(name)}
                    </div>
                ))}
            </div>
            <ModeSelect toggleModal={toggleModal} />
            <ModalAsDropdown
                isModalVisible={isModalVisible}
                toggleModal={toggleModal}
                modalContent={modalContent}
                customModalStyles={modalStyles}
            />
        </div>
    )
}
